module.exports = __webpack_public_path__ + "media/images/products/g1c/g1c-1-400x400-a5267f3e7144d2b852d306343655a1c9.png";